import { GetServerSidePropsContext } from "next";
import { endpointOrigin, refreshFunction } from "./apiConfig";

import { parseCookies } from "nookies";

export const retrieveUserProfile = (
  accessToken?: string,
  ctx?: GetServerSidePropsContext,
  urlOrigin?: string
) => {
  const pathUrl: string = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/account/profile`
    : `${endpointOrigin}/account/profile`;
  const allCookie = ctx ? parseCookies(ctx) : parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  const option = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return fetch(pathUrl, option)
    .then(async (response) => {
      try {
        return response.status === 401
          ? { code: response.status }
          : { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then(async (result) => {
      if (result.code === 401) {
        const refreshToken = await refreshFunction(
          pathUrl,
          option,
          ctx,
          urlOrigin
        );
        return refreshToken;
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const updateUserProfileAPI = (
  paramInput: any,
  ctx?: GetServerSidePropsContext,
  urlOrigin?: string
) => {
  const pathUrl = `${
    urlOrigin && process.env.NEXT_PUBLIC_STATE !== "development"
      ? `${urlOrigin}${endpointOrigin}`
      : endpointOrigin
  }/account/profile`;
  const allCookie = ctx ? parseCookies(ctx) : parseCookies();
  const token = allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];
  const option = {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(paramInput),
  };
  return fetch(pathUrl, option)
    .then(async (response) => {
      try {
        return response.status === 401
          ? { code: response.status }
          : { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then(async (result) => {
      if (result.code === 401) {
        const refreshToken: any = await refreshFunction(
          pathUrl,
          option,
          ctx,
          urlOrigin
        );
        return refreshToken;
      } else {
        return result;
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const retrieveALLApplicationAccesses = (
  apikey?: string,
  ctx?: GetServerSidePropsContext,
  urlOrigin?: string
) => {
  const pathUrl: string = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/account/application-accesses`
    : `${endpointOrigin}/account/application-accesses`;

  const allCookie = ctx ? parseCookies(ctx) : parseCookies();
  const token = apikey
    ? apikey
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  const option = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return fetch(pathUrl, option)
    .then(async (response) => {
      try {
        return response.status === 401
          ? { code: response.status }
          : { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then(async (result) => {
      if (result.code === 401) {
        const refreshToken = await refreshFunction(
          pathUrl,
          option,
          ctx,
          urlOrigin
        );
        return refreshToken;
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const changePasswordAPI = (
  paramInput: any,
  ctx?: GetServerSidePropsContext,
  urlOrigin?: string
) => {
  const pathUrl = `${
    urlOrigin && process.env.NEXT_PUBLIC_STATE !== "development"
      ? `${urlOrigin}${endpointOrigin}`
      : endpointOrigin
  }/account/change-password`;
  const allCookie = ctx ? parseCookies(ctx) : parseCookies();
  const token = allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];
  const option = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(paramInput),
  };
  return fetch(pathUrl, option)
    .then(async (response) => {
      try {
        return response.status === 401
          ? { code: response.status }
          : { code: response.status, result: await response.json() };
      } catch (error) {
        return { code: response.status };
      }
    })
    .then(async (result) => {
      if (result.code === 401) {
        const refreshToken: any = await refreshFunction(
          pathUrl,
          option,
          ctx,
          urlOrigin
        );
        return refreshToken;
      } else {
        return result;
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const settingPasswordAPI = (
  code: string,
  newPassword: string,
  urlOrigin?: string
) => {
  return fetch(
    `${
      urlOrigin ? `${urlOrigin}${endpointOrigin}` : endpointOrigin
    }/account/setting-password`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        code: code,
        newPassword: newPassword,
      }),
    }
  )
    .then((response) => response.status)
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};
